export default function loadSvgSprite(url, el = document.body) {
    return new Promise((resolve) => {
        const div = document.createElement('div');

        const xhr = new XMLHttpRequest();

        xhr.open('GET', url, true);
        xhr.send();

        xhr.onload = function onload() {
            div.innerHTML = xhr.responseText;
            el.insertBefore(div, el.childNodes[0]);
            div.style.display = 'none';
            resolve();
        };
    });
}
